import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {ServiceService} from './service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}
@Component({
	//template: require('./news.component.html')
	selector: 'service-component',
	templateUrl: './pg/service/servicehome.component.html'
	
})

export class ServiceHomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public servicemain; 
    public service:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _pageService: ServiceService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			let slug ='service';
			this.servicemain=slug;
			let limit="8";
			let compservice=document.querySelector('service-component');
			if(compservice){
			if(compservice.getAttribute('limit'))
			{
				limit=compservice.getAttribute('limit');
			}
			}
			 
			   
			   
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);			   
			   this._pageService.getServicehomepage(slug,limit).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                 
                 // this.pagedata.description=data.menu.description;                 
                  //if(data.menu.link_showing_name)
                 // this._title.setTitle(data.menu.link_showing_name);
                  //else
                  //this._title.setTitle(data.menu.link_showing_name);                  
                  this.service=data.service;                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);            
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/service/servicehome.component.ts